import { useState } from "react";
import { toast } from "sonner";
import { MapPin } from "lucide-react";
import { PageHeader } from "@/components/DashboardShell";
import { PrimaryButton } from "@/components/brand";
import { useAuth } from "@/context/AuthContext";
import api, { formatApiError } from "@/lib/api";

export default function MerchantLocations() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState({ name: "", address: "" });
  const [busy, setBusy] = useState(false);
  const locations = user?.locations || [];

  const add = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/merchants/me/locations", form);
      setUser(data);
      setForm({ name: "", address: "" });
      toast.success("Location added");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Failed");
    }
    setBusy(false);
  };

  return (
    <div>
      <PageHeader index="05" eyebrow="Locations" title="Store locations" />
      <div className="grid lg:grid-cols-2 gap-8">
        <div className="border border-gray-200 divide-y divide-gray-200" data-testid="locations-list">
          {locations.length === 0 && <div className="px-5 py-10 text-center text-sm text-gray-400">No locations yet.</div>}
          {locations.map((l, i) => (
            <div key={i} className="flex items-start gap-3 px-5 py-4">
              <MapPin className="h-4 w-4 text-orange-500 mt-0.5" />
              <div>
                <div className="text-sm text-[#0a0a0a]">{l.name}</div>
                <div className="text-xs text-gray-500">{l.address}</div>
              </div>
            </div>
          ))}
        </div>

        <form onSubmit={add} className="border border-gray-200 p-6 space-y-5 h-fit" data-testid="add-location-form">
          <div className="font-mono text-[11px] tracking-[0.14em] uppercase text-gray-400">Add location</div>
          <div>
            <label className="routa-label">Location name</label>
            <input data-testid="location-name" required value={form.name} onChange={(e) => setForm((f) => ({ ...f, name: e.target.value }))} className="routa-input" />
          </div>
          <div>
            <label className="routa-label">Address</label>
            <input data-testid="location-address" required value={form.address} onChange={(e) => setForm((f) => ({ ...f, address: e.target.value }))} className="routa-input" />
          </div>
          <PrimaryButton type="submit" disabled={busy} data-testid="location-add-submit">{busy ? "Adding…" : "Add location"}</PrimaryButton>
        </form>
      </div>
    </div>
  );
}
